const state = {
    data:{
        url: "",
        fileName: "",
        message: "",
        name: ""
    }
};
const getters = {
    getData: state => state.data
};
const mutations = {
    SET_DATA: (state, data) => {
        state.data = {
            url: data.url,
            fileName: data.fileName,
            message: data.message,
            name: data.name
        };
    },
    REMOVE_DATA: state => {
        state.data = {
            url: "",
            fileName: "",
            message: "",
            name: ""
        };
    }
};
const actions = {
    setData: ({commit}, payload) => commit("SET_DATA", payload),
    removeData: ({commit}) => commit("REMOVE_DATA"),
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};